import Section, { SectionVisibilityProps } from './Section';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import useAppMethods from '../../../hooks/utility/useAppMethods';
import { SectionType } from './CheckoutInfoBag';
import { Checkbox } from '@mui/material';

export default function RememberMeSection({ show }: SectionVisibilityProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Checkout:Sections:RememberMeSection' });

  const { toggleLoginModal } = useAppMethods();

  const [checked, setChecked] = useState(false);

  const onClick = () => {
    setChecked(true);

    toggleLoginModal({
      openModal: true,
      onCloseRedirect: () => setChecked(false),
    });
  };

  return (
    <Section
      hideDivider
      show={show}
      id={SectionType.remember_me}
      title={t('title')}
      className="p-md bordered"
      containerClassName="lg:px-none px-md pb-md"
    >
      <Checkbox checked={checked} onChange={onClick} id="remember-me" />
      <label htmlFor="remember-me" className="text-sm ml-xs my-auto">
        {t('form.remember_me.label')}
      </label>
    </Section>
  );
}
